var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from "react";
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { usePlaylists } from "frontend/src/domain/playlists";
import { useViewer } from "frontend/src/domain/session";
export var TimetablePlaylistSelect = function (_a) {
    var _b, _c, _d, _e;
    var value = _a.value, onChange = _a.onChange, playlistNotSelectedError = _a.playlistNotSelectedError;
    var user = useViewer().user;
    var privatePlaylists = usePlaylists({
        type: "private",
        take: 100,
        skip: 0,
        isPublished: true,
        clientId: user === null || user === void 0 ? void 0 : user.clientId,
        orderBy: "updated_at",
        orderByDirection: "desc",
    });
    var publicPlaylists = usePlaylists({
        type: "public",
        take: 100,
        skip: 0,
        isPublished: true,
        clientId: null,
        orderBy: "order",
        orderByDirection: "asc",
    });
    var onPlaylistChange = function (evt) {
        var value = evt.target.value;
        if (typeof value === "string") {
            var id = parseInt(value);
            if (!isNaN(id)) {
                onChange(id);
            }
        }
        else if (typeof value === "number") {
            onChange(value);
        }
    };
    if (privatePlaylists.isLoading || publicPlaylists.isLoading) {
        return React.createElement(Skeleton, null);
    }
    var playlists = __spreadArray(__spreadArray([], ((_c = (_b = privatePlaylists.data) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])), ((_e = (_d = publicPlaylists.data) === null || _d === void 0 ? void 0 : _d.items) !== null && _e !== void 0 ? _e : []));
    return (React.createElement(Box, null,
        React.createElement(FormControl, { fullWidth: true },
            React.createElement(InputLabel, null, "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
            React.createElement(Select, { fullWidth: true, onChange: onPlaylistChange, value: value !== null && value !== void 0 ? value : "", error: playlistNotSelectedError }, playlists.map(function (playlist) { return (React.createElement(MenuItem, { key: playlist.id, value: playlist.id }, playlist.title)); }))),
        playlistNotSelectedError && (React.createElement(FormHelperText, { error: true }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442."))));
};
